// GB42-3427 AC-09: map API error responses to a clean, user-facing message.
// Tracebacks / raw response bodies must never reach the UI.
export type SaveErrorType = {
  status?: number;
  body?: { description?: string | Record<string, string> };
  text?: string;
};

const getDescriptionMessage = (
  description: NonNullable<SaveErrorType['body']>['description'] | undefined,
): string | null => {
  if (typeof description === 'string' && description.trim()) return description;

  if (description && typeof description === 'object') {
    const firstValue = Object.values(description)[0];

    if (typeof firstValue === 'string' && firstValue.trim()) return firstValue;
  }

  return null;
};

export const getSaveErrorMessage = (
  error: SaveErrorType,
  t: (key: string) => string,
  fallbackMessage?: string,
): string => {
  if (error?.status === 403) return t('forms.activationOrder.noPermissionError');
  if (error?.status === 404) return t('forms.activationOrder.notFoundError');

  const descriptionMessage = getDescriptionMessage(error?.body?.description);

  if (descriptionMessage) return descriptionMessage;

  if (fallbackMessage) return fallbackMessage;

  if (error?.status === 400 || error?.status === 422) return t('forms.activationOrder.saveValidationError');

  return t('forms.activationOrder.saveError');
};

export default getSaveErrorMessage;
